<template>
    <div class="mpanel vh-flex">
        <EmptyView v-if="listWord.length == 0" class="vh-full" />
        <el-scrollbar v-else class="vh-full">
            <div class="grid">

                <div v-for="word in listWord" :key="word" class="word-item">
                    <div class="vh-full">
                        <div class="lbword">{{ word.word }}</div>
                        <div class="lbtrans">{{ word.translate }}</div>
                    </div>
                    <div class="vc-flex">
                        <IconView @click.stop="editWord(word)" class="" svgname="ic_edit1" :iconSize="13"
                            :ctnSize="35">
                        </IconView>
                        <IconView @click.stop="deleteWord(word)" class="mgl10" svgname="ic_delete" :iconSize="15"
                            :ctnSize="35">
                        </IconView>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <!--分页-->
        <div class="vpage">
            <el-pagination layout="prev, pager, next,total,jumper" :total="page.totalCount" :page-size="page.size"
                @current-change="onPageChange" />
        </div>
        <!--编辑词汇对话框-->
        <EditWordDialog :show="editDialog.show" :wordItem="editDialog.wordItem" @selectButton="editDialog.callBack">
        </EditWordDialog>
        <!--确认对话框-->
        <ConfirmDialog :showDialog="confirmDialog.show" :title="confirmDialog.title" :message="confirmDialog.message"
            @selectButton="confirmDialog.callBack"></ConfirmDialog>
    </div>
</template>

<script>
import EmptyView from '@/components/EmptyView.vue';
import httpClient from '@/commom/http/httpClient';
import IconView from '@/components/IconView.vue';
import EditWordDialog from '../book/dialog/EditWordDialog.vue';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
export default {
    name: 'NewWordList',
    components: {
        EmptyView,
        IconView,
        EditWordDialog,
        ConfirmDialog
    },
    props: {

    },
    data() {
        return {
            listWord: [],
            page: {
                index: 1,
                size: 30,
                totalCount: 0,
            },
            ///编辑对话框
            editDialog: {
                show: false,
                wordItem: null,
                callBack: null
            },
            ///确认对话框 
            confirmDialog: {
                show: false,
                title: "删除",
                message: "确认删除该词汇吗？",
                callBack: null
            },
        }
    },
    mounted: function () {
        this.loadData()
    },
    methods: {

        ///加载数据
        loadData: function () {
            var that = this
            var req = {
                page: this.page.index,
                size: this.page.size,
                filtterKey: "all",
                keyword: "",
                sortType: ""
            }
            httpClient.invoke("WordItemAPI.GetNewWordPage", req, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (req.page == 1) {
                    that.page.totalCount = res.totalCount
                }
                that.listWord = res.listItem
            })
        },
        ///编辑词汇
        editWord: function (wordItem) {
            this.editDialog.show = true
            this.editDialog.wordItem = wordItem
            var that = this
            this.editDialog.callBack = function (res) {
                that.editDialog.show = false
                if (res.confrim) {
                    that.$message.success("保存成功")
                    that.loadData()
                }
            }
        },
        ///删除词汇
        deleteWord: function (wordItem) {
            var that = this
            this.confirmDialog.show = true
            this.confirmDialog.callBack = function (ok) {
                if (!ok) {
                    return
                }
                var req = {
                    wordId: wordItem.wordId
                }
                httpClient.invoke("WordItemAPI.DeleteWord", req, function (res) {
                    that.confirmDialog.show = false
                    if (res.error) {
                        that.$message.error(res.error)
                        return
                    }
                    that.$message.success("删除成功")
                    that.listWord = that.listWord.filter(function (item) {
                        return item.wordId != wordItem.wordId
                    })
                })
            }
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lbword {
    font-size: 1.4rem;
    font-weight: bold;
    color: var(--ek-text-color1);
}

.lbtrans {
    color: var(--ek-text-color2);
    font-size: 14px;
    margin-top: 10px;
}

.grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
    padding-left: 20px;
    padding-right: 20px;
}

@media (max-width: 1180px) {
    .grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

}

@media (max-width: 760px) {
    .grid {
        grid-template-columns: 1fr;
    }
}

/* 横屏平板 */
@media (min-width: 900px) and (max-width: 1200px) and (orientation: landscape) {
    .grid {
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    }

}

.word-item {
    background: var(--ek-card-color1);
    border-radius: 20px;
    padding: 24px;
    display: grid;
    gap: 14px;
    min-height: 210px;
    position: relative;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
}

.word-item:hover {
    /* transform: translateY(-6px); */
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.16);
}

.vpage {
    padding-left: 20px;
    padding-bottom: 15px;
    padding-right: 20px;
    padding-top: 15px;
}
</style>
